/* global axios */
import ApiClient from './ApiClient';

class SocialCommentAutomationsAPI extends ApiClient {
  constructor() {
    super('social_comment_automations', { accountScoped: true });
  }

  connectionHealth() {
    return axios.get(`${this.url}/connection_health`);
  }

  // Publicações recentes da conta, para escolher em quais posts a regra vale.
  media(inboxId) {
    return axios.get(`${this.baseUrl()}/instagram/media`, {
      params: { inbox_id: inboxId },
    });
  }
}

export default new SocialCommentAutomationsAPI();
